import {
  Colors,
  MOON_250,
  MOON_650,
} from '@wandb/weave/common/css/globals.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const SectionTitle = styled.div`
  font-weight: 600;
  font-size: 16px;
  line-height: 32px;
  margin: 24px 0 8px 0;
`;
SectionTitle.displayName = 'S.SectionTitle';

// TODO: Decide if we want to share these with JobMetadata or make a reusable component
export const MetadataTable = styled.div`
  background-color: ${Colors.WHITE};
  width: 100%;
  border: 1px solid ${MOON_250};
  border-radius: 4px;
  padding: 12px;
`;
MetadataTable.displayName = 'S.MetadataTable';

export const Tr = styled.div`
  min-height: 36px;
  display: flex;
  align-items: center;
`;
Tr.displayName = 'S.Tr';

export const Property = styled.div`
  color: ${MOON_650};
  font-weight: 600;
  white-space: nowrap;
  width: 200px;
`;
Property.displayName = 'S.displayName';
